//@flow
import React from 'react';
import * as Immutable from 'immutable';
import moment from 'moment-timezone';
import SingleSlotSelector from 'common/entity/components/slot/SingleSlotSelector';
import { TimeSlot } from 'common/models/internal/TimeSlot';
import { SlotType } from 'common/enums/SlotEnum';
import { Button } from 'common/components/core/button';
import { DateInputFormats } from 'common/utils/DateTimeUtils';

class EverydaySlotsSelector extends React.PureComponent {
    render() {
        const {
            timeSlots,
            theme,
            t,
            onDeleteSlot,
            onAddSlot,
            onSlotChange,
            createDefaultSlot
        } = this.props;
        let slots = null;

        // For everyday, show the first day's (monday) slots, every day should be same
        if (timeSlots.length) {
            const [firstDay] = timeSlots;
            ({ slots } = firstDay);
        } else {
            slots = Immutable.List([TimeSlot.fromJS(createDefaultSlot())]);
        }
        const slotSelectors = slots.map((slot, index) => {
            const start = moment(slot.start, DateInputFormats.HOUR24_SHORT);
            const end = moment(slot.end, DateInputFormats.HOUR24_SHORT);

            let isInvalid = false;
            if (index > 0) {
                isInvalid = slot.isTimeSlotOverlapping(slots, index);
            }

            return (
                <SingleSlotSelector
                    key={index}
                    t={t}
                    theme={theme}
                    start={start}
                    end={end}
                    slotFor={SlotType.EVERYDAY}
                    index={index}
                    onChange={onSlotChange}
                    onDelete={index === 0 ? null : onDeleteSlot}
                    error={
                        isInvalid
                            ? t('validations:timeSlot.overlappingSlots')
                            : null
                    }
                />
            );
        });

        return (
            <div className={theme.slotOptionsWrap}>
                {slotSelectors}
                <Button
                    className={theme.addSlotButton}
                    semibold
                    theme={theme}
                    onClick={onAddSlot}
                    fieldId={SlotType.EVERYDAY}
                    ripple={false}
                    label={`+ ${t('slotSelector.addSlot')}`}
                />
            </div>
        );
    }
}

export { EverydaySlotsSelector };
export default EverydaySlotsSelector;
